import React from 'react';
import { GetMediaReturn } from '../../utils/mediaHelpers';

type Props = {
  media?: GetMediaReturn;
  actions?: JSX.Element;
  drupalId: string;
  children: React.ReactNode;
};

const Highlight: React.FC<Props> = function ({ media, children, actions, drupalId }) {
  return (
    <div
      data-id={drupalId}
      className="pds-m-auto pds-mb-4 pds-flex pds-h-full pds-flex-col pds-py-5 pds-text-center"
    >
      <div className="pds-mx-auto pds-mb-4 pds-w-7 pds-overflow-hidden lg:pds-w-full">{media}</div>
      <div className="pds-mb-3.5 pds-flex-grow pds-px-4">{children}</div>
      <div>{actions}</div>
    </div>
  );
};

export default Highlight;
